import { getSimpleBoolItemLabel } from "@components/smart/FieldInfo";
import { isNotDefined } from "@utils/general";

import { TValue } from "../global.types";

class BooleanType {
    static parse(value: string): boolean {
        if (isNotDefined(value) || value === "") {
            return null;
        }

        value = value.toLowerCase();

        if (value === "true" || value === getSimpleBoolItemLabel(true).toLowerCase()) {
            return true;
        } else if (value === "false" || value === getSimpleBoolItemLabel(false).toLowerCase()) {
            return false;
        }

        return null;
    }

    static format(value: boolean): string {
        return getSimpleBoolItemLabel(value);
    }

    static isValid(value: boolean): boolean {
        return typeof value === "boolean";
    }
}

export const booleanFormatter = (val: TValue): string => {
    return BooleanType.format(val as boolean);
};

export default BooleanType;
